import { AxiosRequestConfig } from 'axios'

export const pendingRequest = new Map()

export const createRequestKey = (config: AxiosRequestConfig) => {
  return [config.method, config.url].join('&')
}
